export default __webpack_public_path__ + "static/media/bear@2x.a988313c.png";